import { aircraftContent } from './elementContent/aircraftContent';
import { deliveryContent } from './elementContent/deliveryContent';
import { designContent } from './elementContent/designContent';
import { employeeContent } from './elementContent/employeeContent';
import { loanOfferContent } from './elementContent/loanOfferContent';
import { loanTakenContent } from './elementContent/loanTakenContent';
import { stockOfferContent } from './elementContent/stockOfferContent';

export const elementContent = {
  employee: employeeContent,
  aircraft: aircraftContent,
  design: designContent,
  stockOffer: stockOfferContent,
  loanOffer: loanOfferContent,
  loanTaken: loanTakenContent,
  delivery: deliveryContent,
};
